import * as React from 'react'
function SvgReceipt(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32 4H8c-1.2 0-2 .8-2 2v30l6-4 4 4 4-4 4 4 4-4 6 4V6c0-1.2-.8-2-2-2zm-4 20H12v-4h16v4zm0-8H12v-4h16v4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgReceipt
